import { useMemo } from 'react';

import { Placement } from '@floating-ui/core';

const ARROW_OFFSET = 3;
const ARROW_SIZE = '6px';

interface ArrowPositionParams {
  placement: Placement;
  arrowY: number;
  arrowX: number;
}

function arrowPosition({ placement, arrowY, arrowX }: ArrowPositionParams) {
  switch (placement) {
    case 'left': {
      return {
        right: -ARROW_OFFSET,
        top: arrowY ?? '',
      };
    }
    case 'right': {
      return {
        left: -ARROW_OFFSET,
        top: arrowY ?? '',
      };
    }
    case 'top': {
      return {
        left: arrowX ?? '',
        bottom: -ARROW_OFFSET,
      };
    }
    case 'bottom': {
      return {
        left: arrowX ?? '',
        top: -ARROW_OFFSET,
      };
    }
    default: {
      return {};
    }
  }
}

function arrowStyle(arrowPositionParams: ArrowPositionParams) {
  return {
    transform: 'rotate(45deg)',
    height: ARROW_SIZE,
    width: ARROW_SIZE,
    ...arrowPosition(arrowPositionParams),
  };
}

export const usePopperArrowStyle = ({
  arrowX,
  arrowY,
  placement,
}: ArrowPositionParams) =>
  useMemo(
    () =>
      arrowStyle({
        placement: placement,
        arrowY: arrowY,
        arrowX: arrowX,
      }),
    [arrowX, arrowY, placement]
  );
